// extracted by mini-css-extract-plugin
export default {"scrollDetector":"fUyCRdvj"};